import { render, staticRenderFns } from "./CrashPaymentVault.vue?vue&type=template&id=2b3a352a&"
import script from "./CrashPaymentVault.vue?vue&type=script&lang=js&"
export * from "./CrashPaymentVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports